import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { PermissionService } from '@services/permission.service';

export const adminPermissionGuard: CanActivateChildFn = async (route) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  await permissionService.getPermissions();

  const permission = route.data?.['permission'] as string | undefined;
  const permissions = route.data?.['permissions'] as string[] | undefined;

  if (permission && !permissionService.hasPermission(permission)) {
    return router.createUrlTree(['/not-found']);
  }

  if (Array.isArray(permissions)) {
    const hasAny = permissions.some((item) => permissionService.hasPermission(item));
    if (!hasAny) {
      return router.createUrlTree(['/not-found']);
    }
  }

  return true;
};
